import Clarity from '@microsoft/clarity';
import { useEffect } from 'react';
import { User } from '../apiTypes';

const useInitTracking = (user: DbDocument<User> | undefined) => {
  useEffect(() => {
    if (user) {
      Clarity.identify(user.id, undefined, undefined, user.displayName);
      Clarity.setTag('type', 'Admin');
      Clarity.setTag('user', user.displayName);
      Clarity.setTag('email', user.email || 'Unknown email');
      Clarity.setTag('phone', user.phone || 'Unknown phone');
    }
  }, [user]);
};

export default useInitTracking;
